/*
 * @Author: changdou.fe@bytedance.com
 * @Date: 2025-11-09 12:57:34
 * @LastEditors: changdou.fe@bytedance.com
 * @LastEditTime: 2025-12-03 11:15:58
 */
'use client';
import { Download } from 'lucide-react';
import { Tooltip } from 'antd';
import { useIsMobile } from '@/hooks/use-mobile';

export default function CoStreamTools() {
  const handleTools = () => {
    window.open('/stream/tools', '_blank')
  };
  const isMobile = useIsMobile();
  if (process.env.isProd || isMobile) {
    return null;
  }
  return (
    <Tooltip title="下载Billion 直播助手">
      <div 
        className="transition-all flex items-center cursor-pointer gap-1 rounded-md bg-background-card border border-button-border/85 relative p-2 hover:border-button-border text-font-secondary hover:text-font-primary hover:bg-secondary-hover"
        onClick={handleTools}
      >
        <Download className="w-4 h-4" />
      </div>
    </Tooltip>
  );
}
